var map = {
	"./acrobat.png": 8035,
	"./alchemist.png": 9799,
	"./alhadikhia.png": 8723,
	"./alsaahir.png": 3393,
	"./amnesiac.png": 5118,
	"./angel.png": 6474,
	"./apprentice.png": 819,
	"./artist.png": 6835,
	"./assassin.png": 3169,
	"./atheist.png": 946,
	"./balloonist.png": 5926,
	"./banshee.png": 8063,
	"./barber.png": 8069,
	"./barista.png": 2437,
	"./baron.png": 8230,
	"./beggar.png": 1082,
	"./bishop.png": 5343,
	"./bonecollector.png": 1594,
	"./boomdandy.png": 3682,
	"./bountyhunter.png": 7479,
	"./buddhist.png": 1990,
	"./bureaucrat.png": 367,
	"./butcher.png": 177,
	"./butler.png": 4697,
	"./cannibal.png": 6214,
	"./cerenovus.png": 7637,
	"./chambermaid.png": 1146,
	"./chef.png": 1248,
	"./choirboy.png": 5081,
	"./clockmaker.png": 5102,
	"./courtier.png": 759,
	"./cultleader.png": 2763,
	"./custom.png": 7037,
	"./damsel.png": 5533,
	"./deusexfiasco.png": 8141,
	"./deviant.png": 1683,
	"./devilsadvocate.png": 5549,
	"./djinn.png": 393,
	"./doomsayer.png": 5142,
	"./dreamer.png": 1610,
	"./drunk.png": 3669,
	"./duchess.png": 2491,
	"./empath.png": 5695,
	"./engineer.png": 7571,
	"./evil.png": 1836,
	"./eviltwin.png": 7664,
	"./exorcist.png": 5858,
	"./fabled.png": 5025,
	"./fanggu.png": 1833,
	"./farmer.png": 4390,
	"./fearmonger.png": 5297,
	"./fibbin.png": 9332,
	"./fiddler.png": 5076,
	"./fisherman.png": 2776,
	"./flowergirl.png": 6053,
	"./fool.png": 647,
	"./fortuneteller.png": 9336,
	"./gambler.png": 4306,
	"./gangster.png": 782,
	"./general.png": 2990,
	"./goblin.png": 1730,
	"./godfather.png": 8536,
	"./golem.png": 7274,
	"./good.png": 6832,
	"./goon.png": 1273,
	"./gossip.png": 5965,
	"./grandmother.png": 4950,
	"./gunslinger.png": 7768,
	"./harlot.png": 6226,
	"./harpy.png": 3865,
	"./hatter.png": 3490,
	"./hellslibrarian.png": 5477,
	"./heretic.png": 6314,
	"./highpriestess.png": 6251,
	"./huntsman.png": 7893,
	"./imp.png": 2830,
	"./innkeeper.png": 6580,
	"./investigator.png": 9813,
	"./judge.png": 6306,
	"./juggler.png": 8785,
	"./kazali.png": 1465,
	"./king.png": 6865,
	"./klutz.png": 1938,
	"./knight.png": 3395,
	"./legion.png": 2339,
	"./leviathan.png": 3245,
	"./librarian.png": 651,
	"./lilmonsta.png": 4090,
	"./lleech.png": 1424,
	"./lunatic.png": 2561,
	"./lycanthrope.png": 8746,
	"./magician.png": 4214,
	"./marionette.png": 712,
	"./mastermind.png": 7100,
	"./mathematician.png": 3850,
	"./matron.png": 8054,
	"./mayor.png": 8827,
	"./mephit.png": 3304,
	"./mezepheles.png": 295,
	"./minion.png": 847,
	"./minstrel.png": 3415,
	"./monk.png": 3100,
	"./moonchild.png": 8749,
	"./mutant.png": 4473,
	"./nightwatchman.png": 2666,
	"./noble.png": 1004,
	"./nodashii.png": 2458,
	"./ogre.png": 2306,
	"./ojo.png": 3073,
	"./oracle.png": 9624,
	"./organgrinder.png": 5705,
	"./outsider.png": 8814,
	"./pacifist.png": 5873,
	"./philosopher.png": 3300,
	"./pithag.png": 1282,
	"./pixie.png": 8637,
	"./plaguedoctor.png": 5985,
	"./plus.png": 4511,
	"./po.png": 5631,
	"./poisoner.png": 6763,
	"./politician.png": 4265,
	"./poppygrower.png": 8828,
	"./preacher.png": 3213,
	"./professor.png": 889,
	"./psychopath.png": 7826,
	"./pukka.png": 4486,
	"./puzzlemaster.png": 7002,
	"./ravenkeeper.png": 6965,
	"./recluse.png": 3035,
	"./revolutionary.png": 9038,
	"./riot.png": 8118,
	"./sage.png": 6544,
	"./sailor.png": 8984,
	"./saint.png": 4811,
	"./savant.png": 7884,
	"./scapegoat.png": 6701,
	"./scarletwoman.png": 3957,
	"./seamstress.png": 4201,
	"./sentinel.png": 4213,
	"./shabaloth.png": 2034,
	"./shugenja.png": 922,
	"./slayer.png": 3802,
	"./snakecharmer.png": 9900,
	"./snitch.png": 7988,
	"./soldier.png": 2231,
	"./spiritofivory.png": 3379,
	"./spy.png": 4013,
	"./steward.png": 6050,
	"./stormcatcher.png": 3877,
	"./summoner.png": 817,
	"./sweetheart.png": 6356,
	"./tealady.png": 3009,
	"./thief.png": 7112,
	"./tinker.png": 5380,
	"./towncrier.png": 4055,
	"./toymaker.png": 3163,
	"./undertaker.png": 5466,
	"./vigormortis.png": 4969,
	"./villageidiot.png": 4883,
	"./virgin.png": 6954,
	"./vizier.png": 5485,
	"./vortox.png": 6142,
	"./voudon.png": 152,
	"./washerwoman.png": 245,
	"./widow.png": 3729,
	"./witch.png": 6909,
	"./x.png": 1139,
	"./yaggababble.png": 4520,
	"./zealot.png": 7044,
	"./zombuul.png": 8899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;